export default function HerQuestions({ session, update, goTo }) {
  const herQuestions =
    session.herQuestions && session.herQuestions.length > 0
      ? session.herQuestions
      : [""];

  const setQ = (i, value) => {
    const next = [...herQuestions];
    next[i] = value;
    update({ herQuestions: next });
  };

  const addQuestion = () => {
    update({ herQuestions: [...herQuestions, ""] });
  };

  const removeQuestion = (i) => {
    if (herQuestions.length <= 1) return;
    const next = herQuestions.filter((_, j) => j !== i);
    update({ herQuestions: next });
  };

  return (
    <section className="section her-section scene-mount">
      <div className="her-inner">
        <p className="section-eyebrow">part two</p>
        <h2 className="section-title">your turn.</h2>
        <p className="section-sub">
          ask whatever you can think of, and i'll answer.
          <br />
          as many as you want — silly, weird, anything.
        </p>

        <div className="her-list">
          {herQuestions.map((q, i) => (
            <div key={i} className="her-row">
              <label className="her-label">
                <span>question {i + 1}</span>
                {herQuestions.length > 1 && (
                  <button
                    type="button"
                    onClick={() => removeQuestion(i)}
                    aria-label="remove"
                    className="her-remove"
                  >
                    × remove
                  </button>
                )}
              </label>
              <textarea
                value={q}
                placeholder="ask away…"
                rows={3}
                onChange={(e) => setQ(i, e.target.value)}
              />
            </div>
          ))}
        </div>

        <button type="button" onClick={addQuestion} className="her-add">
          + add another question
        </button>

        <div className="scene-nav">
          <button className="btn" onClick={() => goTo("miniGame")}>
            <span className="btn-text">continue →</span>
          </button>
        </div>
      </div>
    </section>
  );
}
